import { Component, inject, OnInit, input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltip } from '@angular/material/tooltip';
import { Auth0Store } from '../../../auth0/store';

import { SnakeCaseTitlePipe } from '../../../../shared-lazy/pipes/snakeCaseTitle.pipe';
import { AvatarComponent } from '../../../../shared/components/avatar/avatar.component';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { DotsLoaderComponent } from '../../../../shared/components/dots-loader/dots-loader.component';
import { ApplicativeRole, DEFAULT_ROLE_NAME } from '../../../auth0/models';
import { RoleDialogComponent, RoleDialogData } from '../role-dialog/role-dialog.component';

const AVATAR_COLORS = ['#007da8', '#6b8fa3', '#8e6fad', '#c06b84', '#5a9a7a', '#d49a57'];
const MAX_VISIBLE_AVATARS = 5;

@Component({
  selector: 'gnx-roles-permissions',
  templateUrl: './roles-permissions.component.html',
  styleUrls: ['./roles-permissions.component.scss'],
  imports: [DotsLoaderComponent, AvatarComponent, MatTooltip, MatMenuModule, SnakeCaseTitlePipe, ButtonComponent],
})
export class RolesPermissionsComponent implements OnInit {
  private dialog = inject(MatDialog);

  protected auth0Store = inject(Auth0Store);
  readonly isAdmin = input<boolean>(undefined);

  ngOnInit(): void {
    this.auth0Store.getApplicativeRoles();
    this.auth0Store.loadDefaultRole();
    this.auth0Store.loadAvailablePermissions();
  }

  getAvatarColor(index: number): string {
    return AVATAR_COLORS[index % AVATAR_COLORS.length];
  }

  getVisibleUsers(role: ApplicativeRole): { name: string; email: string }[] {
    return (role.assigned_users || []).slice(0, MAX_VISIBLE_AVATARS);
  }

  getOverflowCount(role: ApplicativeRole): number {
    return Math.max(0, (role.assigned_users?.length || 0) - MAX_VISIBLE_AVATARS);
  }

  getOverflowUsersTooltip(role: ApplicativeRole): string {
    return (role.assigned_users || [])
      .slice(MAX_VISIBLE_AVATARS)
      .map((u) => u.name || u.email)
      .join(', ');
  }

  openCreateDialog(): void {
    this.openDialog({ mode: 'create', isAdmin: true });
  }

  openRoleDialog(role: ApplicativeRole): void {
    this.openDialog({
      mode: this.isAdmin() ? 'edit' : 'view',
      role,
      isAdmin: this.isAdmin(),
      isDefaultRole: role.role === DEFAULT_ROLE_NAME,
    });
  }

  private openDialog(data: RoleDialogData): void {
    this.dialog.open(RoleDialogComponent, {
      width: '680px',
      maxHeight: '85vh',
      backdropClass: 'popup-backdrop',
      panelClass: 'popup-panel',
      data,
    });
  }
}
